import React from "react";

/**
 *
 * @param props
 * onClick {function}
 * goTo {String}
 * otherTab {Boolean}
 * buttonText {String}
 * position {String} left | right
 * image {String}
 */
function IconButton(props) {
    // const images = require.context('../../assets', true);
    // const img = props.image ? images('./' + props.image) : "";
    const imag = props.image ?require('../../assets/'+ props.image): "";

    return (
        <a onClick={props.onClick? () => {
            props.onClick()
        }: () => {}} target={props.otherTab? "_blank" : "_self"} rel={"noreferrer"} href={props.goTo} className={`icon_button ${props.customClasses || '' }`}>
            {props.position === 'left' && <img className={'icon_button-icon icon_button-icon--left'} src={imag.default} alt={'icon'}/>}
            <p className={'icon_button-text'}>{props.buttonText}</p>
            {props.position === 'right' && <img className={'icon_button-icon icon_button-icon--right'} src={imag.default} alt={'icon'}/>}
        </a>
    )
}

export default IconButton;